import { render, staticRenderFns } from "./ApelacionDetalles.vue?vue&type=template&id=5b6a25b0&"
import script from "./ApelacionDetalles.vue?vue&type=script&lang=js&"
export * from "./ApelacionDetalles.vue?vue&type=script&lang=js&"
import style0 from "./ApelacionDetalles.vue?vue&type=style&index=0&id=5b6a25b0&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports